var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_gitlab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "16 28.896 16 28.896 21.156 13.029 10.844 13.029 16 28.896",
    style: {
      fill: "#e24329"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 28.896 10.844 13.029 3.619 13.029 16 28.896",
    style: {
      fill: "#fc6d26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.619,13.029h0L2.052,17.851a1.067,1.067,0,0,0,.388,1.193L16,28.9,3.619,13.029Z",
    style: {
      fill: "#fca326"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.619,13.029h7.225L7.739,3.473a.534.534,0,0,0-1.015,0L3.619,13.029Z",
    style: {
      fill: "#e24329"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 28.896 21.156 13.029 28.381 13.029 16 28.896",
    style: {
      fill: "#fc6d26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.381,13.029h0l1.567,4.822a1.067,1.067,0,0,1-.388,1.193L16,28.9,28.381,13.029Z",
    style: {
      fill: "#fca326"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.381,13.029H21.156l3.105-9.557a.534.534,0,0,1,1.015,0l3.105,9.557Z",
    style: {
      fill: "#e24329"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.61a4e3988f82f2b071f044f432b05b1c.svg";
export { ForwardRef as ReactComponent };